import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getOutreaches = fp.get('outreach.outreach');

export const getAll = createSelector(getOutreaches, fp.get('all'));

export const getAllValues = createSelector(getAll, fp.values);

export const getItemForId = createSelector((_, id) => id, getAll, fp.get);

export const getIsFetching = createSelector(getOutreaches, fp.get('fetching'));
export const getIsFetched = createSelector(getOutreaches, fp.get('fetched'));
export const getFetchingError = createSelector(
  getOutreaches,
  fp.get('fetchingError')
);

export const getIsSaving = createSelector(getOutreaches, fp.get('saving'));
export const getIsSaved = createSelector(getOutreaches, fp.get('saved'));
export const getSavingError = createSelector(
  getOutreaches,
  fp.get('savingError')
);

export const getIsDeleting = createSelector(getOutreaches, fp.get('deleting'));
export const getIsDeleted = createSelector(getOutreaches, fp.get('deleted'));
export const getDeletingError = createSelector(
  getOutreaches,
  fp.get('deletingError')
);

export const getOrder = createSelector(getOutreaches, fp.get('order'));
